<iframe *ngIf="safeUrl&&signedUrl" [src]="safeUrl" title="description"></iframe>
<img *ngIf="safeUrl && signedUrl && isImage" [src]="safeUrl" alt="Image">
